import { Card, editorConfigOptions, ErrorMessage, useRef } from "@";
import type { ProjectDetailsSectionProps } from "./types";
import JoditEditor from "jodit-react";

export const ProjectDetailsSection = ({
  watch,
  setValue,
  getValues,
  errors,
  show,
  // isSubmitSuccessful,
  // handleUpload,
}: ProjectDetailsSectionProps) => {
  const editor = useRef(null);

  return (
    <Card isOpen={false} title=" تفاصيل المشروع" className="lg:col-span-2">
      {/*<UploadImageCard*/}
      {/*  className="h-20"*/}
      {/*  show={!show}*/}
      {/*  description="*/}
      {/*  يمكنك هنا رفع صورة توضح تفاصيل المشروع*/}
      {/*  "*/}
      {/*  title="صورة تفاصيل المشروع"*/}
      {/*  success={isSubmitSuccessful}*/}
      {/*  src={getValues("projectDescriptionImagesUrls") as string}*/}
      {/*  error={*/}
      {/*    (errors.projectDescriptionImages as { message?: string })?.message*/}
      {/*  }*/}
      {/*  upload={(file: File) => handleUpload(file, "projectDescriptionImages")}*/}
      {/*/>*/}

      {/*<div className="inline-flex w-full items-center justify-center">*/}
      {/*  <hr className="my-5 h-px w-64 border-0 bg-gray-300" />*/}
      {/*  <span className="absolute left-1/2 -translate-x-1/2 bg-white px-3 text-sm text-gray-400">*/}
      {/*    أو*/}
      {/*  </span>*/}
      {/*</div>*/}

      {/*<label className="input-label">يمكنك هنا كتابة تفاصيل المشروع كنص</label>*/}
      {show && getValues("projectDetails") ? (
        <div
          dangerouslySetInnerHTML={{
            __html: getValues("projectDetails") as string,
          }}
        />
      ) : (
        <JoditEditor
          ref={editor}
          value={watch("projectDetails") as string}
          config={editorConfigOptions}
          tabIndex={1}
          onChange={(newContent: string) =>
            setValue("projectDetails", newContent)
          }
        />
      )}

      <ErrorMessage
        value={(errors.projectDetails as { message?: string })?.message}
      />
    </Card>
  );
};
